import { createFileRoute } from '@tanstack/react-router'
import { UserAreaPage } from '@/components/UserAreaPage'

export const Route = createFileRoute('/user-area')({
    component: UserAreaPage,
})

